import DownloadsConfiguratorEmailModal, {
  DOWNLOADS_CONFIGURATOR_EMAIL_MODAL,
} from './DownloadsConfiguratorEmailModal';

export { DOWNLOADS_CONFIGURATOR_EMAIL_MODAL };

export default DownloadsConfiguratorEmailModal;
